// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1c6h4","col":"styles_col__1yFhP"};